import gql from 'graphql-tag';

export const MARK_MEMBERS_AS_IMPORTANT = gql`
  mutation MarkMembersAsImportantMutation($memberIds: [Int!]!, $isImportant: Boolean = true) {
    markMembersAsImportant(memberIds: $memberIds, isImportant: $isImportant)
  }
`;
